import { ActionNodeDataDto, ActionNodeEmailConfigDto } from "@babackapp/private-api-client/types";
import useCurrentShopSuspense from "./use-current-shop-suspense";
import useGetAllWorkflowsV2 from "@babackapp/private-api-client/client/use-get-all-workflows-v2";


export default function useTemplateWorkflowsDependencies(templateId?: string | null) {
  const { data: shop } = useCurrentShopSuspense();
  const { data: workflows} = useGetAllWorkflowsV2(shop.id);

  return (workflows || [])
    .filter(workflow => {
      return workflow.definition.nodes?.some(node => {
        return node.type === "action"
          && (node?.data as ActionNodeDataDto)?.actionType === 'send_tracking_email'
        && ((node?.data as ActionNodeDataDto).config as ActionNodeEmailConfigDto)?.templateId === templateId;
      })
    });
}
